<template>
	<p class="uppercase text-xs font-main-bold py-4" v-if="game && title">
		{{title}}
	</p>
</template>

<script>
	export default {
		name: 'GameHeader',
		props: {
			game: {
				type: Object,
				required: true,
				default: null
			}
		},
		computed: {
			title() {
				if (!this.game)
					return ''

				return (this.game.title ? this.game.title : this.game.name)
			}
		},
	}
</script>

<style lang="scss" scoped></style>
